import { GraphandModelData } from "graphand-js";
import React from "react";

class Activity extends GraphandModelData {
  static apiIdentifier = "activities";
  static defaultField = "name";
}

export default Activity;
